import React from 'react'
import Logo from '../../assets/images/logoWithSlogan.jpg'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../components/ui/form'
import { forgotPasswordSchema } from '../../lib/schemas'
import { Input } from '../../components/ui/input'
import { Button } from '../../components/ui/button'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useMutation } from '@tanstack/react-query'
import { publibAxios } from '../../lib/axios'
import { ADMINFORGET_PASSWORD } from '../../constant/endpoints'
import { useNavigate } from 'react-router-dom'
import { toastHandler } from '../../lib/helper'

const ForgetPassword = () => {

    const navigate = useNavigate();

    const form = useForm({
        resolver: zodResolver(forgotPasswordSchema),
        defaultValues: {
            email: "",
        }
    })

    const { mutate } = useMutation({
        mutationFn: (values) => publibAxios(ADMINFORGET_PASSWORD, values),
        onSuccess: (res) => {
            if (res.ResponseCode === "1") {
                navigate('/admin/verify-otp', { state: { email: form.getValues()?.email } })
            }
            return toastHandler(res)
        },
        onError: (res) => {
            return toastHandler(res);
        },
    })

    const onSubmit = (values) => {
        mutate(values)
    }
    return (
        <div className='w-full max-w-sm h-screen mx-auto flex flex-col justify-center'>
            <div className='space-y-10'>
                <div className='space-y-2'>
                    <div className='max-w-[350px] mx-auto mb-6'>
                        <img src={Logo} alt="logo" />
                    </div>
                    <h1 className='text-primary text-2xl font-lato font-semibold'>Forgot password?</h1>
                    <p className='text-text2'>No worries, we'll send you reset instructions.</p>
                </div>
                <Form {...form}>
                    <form
                        onSubmit={form.handleSubmit(onSubmit)}
                        className="w-full h-max space-y-8"
                    >
                        <FormField
                            control={form.control}
                            name="email"
                            render={({ field }) => (
                                <FormItem className="w-full">
                                    <FormLabel className="text-text text-base font-lato">
                                        Email
                                    </FormLabel>
                                    <FormControl>
                                        <Input
                                            {...field}
                                            placeholder="Enter your email"
                                            onChange={({ target: { value } }) => form.setValue("email", value.toLowerCase())}
                                        />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />

                        <Button className="w-full">Send Email</Button>

                    </form>
                </Form>
            </div>
        </div>
    )
}

export default ForgetPassword